import React from 'react'
import VideoTourSvg from 'images/modules/Shared/i-video-tour.svg?raw'

export { default as VideoTourUrl } from 'images/modules/Shared/i-video-tour.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: VideoTourSvg}} />
)
